export const environment = {
    production: true,
    apis: {
        public: 'https://api.netride.mx/api',
        base: 'https://api.netride.mx/api',
        socketUrl: 'https://api.netride.mx:4601'
    }
};
